import { AbsoluteFill, Img, interpolate, spring, useCurrentFrame, useVideoConfig, staticFile } from 'remotion';
import React from 'react';
import { loadFont } from "@remotion/google-fonts/Cinzel";

const { fontFamily: cinzel } = loadFont("normal", { weights: ["700"], subsets: ["latin"] });

// A simple star/particle background could be nice, or just a mystical radial gradient.
const Background: React.FC = () => {
    const frame = useCurrentFrame();

    const rotation = interpolate(frame, [0, 270], [0, 20]);
    const scale = interpolate(frame, [0, 270], [1, 1.1]);

    return (
        <AbsoluteFill style={{ 
            backgroundColor: '#050212', 
            backgroundImage: 'radial-gradient(circle at center, #1a0b35 0%, #050212 100%)',
            transform: `scale(${scale}) rotate(${rotation}deg)`,
            transformOrigin: 'center center'
        }}>
            {/* Adding some subtle light bursts */}
            <div style={{
                position: 'absolute',
                top: '20%',
                left: '20%',
                width: '60%',
                height: '60%',
                background: 'radial-gradient(circle, rgba(255, 165, 0, 0.2) 0%, transparent 60%)',
                filter: 'blur(50px)'
            }} />
        </AbsoluteFill>
    );
};

const Title: React.FC = () => {
    const frame = useCurrentFrame();
    const { fps } = useVideoConfig();
    
    // Animate letters one by one or a big fade + scale
    const text = "HAR HAR MAHADEV";
    
    // Scale the text in
    const scale = spring({
        fps,
        frame: frame - 90, // Starts later
        config: { damping: 12 },
    });
    
    const opacity = interpolate(frame, [90, 135], [0, 1], {
        extrapolateLeft: 'clamp',
        extrapolateRight: 'clamp',
    });

    const glow = interpolate(frame, [135, 180, 225, 270], [10, 30, 10, 30], {
        extrapolateRight: 'clamp',
    });

    return (
        <AbsoluteFill style={{ justifyContent: 'center', alignItems: 'center', top: '15%' }}>
            <h1 style={{
                fontFamily: cinzel,
                fontSize: '150px',
                fontWeight: 'bold',
                color: '#FFD700', // Golden
                textShadow: `0 0 ${glow}px rgba(255, 215, 0, 0.8), 0 0 ${glow * 2}px rgba(255, 69, 0, 0.5)`,
                letterSpacing: '10px',
                margin: 0,
                transform: `scale(${scale})`,
                opacity: opacity,
                textAlign: 'center',
                textTransform: 'uppercase',
                zIndex: 10
            }}>
                {text}
            </h1>
        </AbsoluteFill>
    );
};

export const ShivlingCTA: React.FC = () => {
	const frame = useCurrentFrame();
	const { fps } = useVideoConfig();

    // Shivling emerging animation
    // Emerge from bottom: Y translation
    const shivlingY = spring({
        fps,
        frame,
        config: {
            damping: 15,
            mass: 2,
        },
        durationInFrames: 90,
    });
    
    const translateY = interpolate(shivlingY, [0, 1], [500, 0]);
    
    // Scale up slightly as it emerges
    const shivlingScale = interpolate(frame, [0, 270], [0.8, 1.1]);

    const imageOpacity = interpolate(frame, [0, 45], [0, 1], {
        extrapolateLeft: 'clamp',
        extrapolateRight: 'clamp',
    });

	const S = 1280 / 1920;
	return (
		<AbsoluteFill style={{ overflow: 'hidden' }}>
      <div style={{ position: 'absolute', left: 0, top: 0, width: 1920, height: 1080, transform: `scale(${S})`, transformOrigin: 'top left', backgroundColor: 'black', overflow: 'hidden' }}>
            <Background />
            
            <AbsoluteFill style={{ 
                justifyContent: 'flex-end', 
                alignItems: 'center',
                paddingBottom: '50px' 
            }}>
                <Img 
                    src={staticFile('shivling.png')} 
                    style={{
                        height: '80%',
                        objectFit: 'contain',
                        transform: `translateY(${translateY}px) scale(${shivlingScale})`,
                        opacity: imageOpacity,
                        filter: `drop-shadow(0px 0px 50px rgba(0, 150, 255, 0.6))` // Mystic blue glow around the Shivling
                    }} 
                />
            </AbsoluteFill>

            {/* HAR HAR MAHADEV text sequence */}
            <Title />

            {/* Final Flash/Fade effect to make it cinematic */}
            <AbsoluteFill style={{
                backgroundColor: 'white',
                opacity: interpolate(frame, [240, 262, 270], [0, 1, 0], {
                    extrapolateLeft: 'clamp',
                    extrapolateRight: 'clamp',
                }),
                pointerEvents: 'none',
                zIndex: 20
            }} />
      </div>
		</AbsoluteFill>
	);
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
